module.exports = __webpack_public_path__ + "media/catalog/error-close-svgrepo-com-9c72f753.svg";